import React, { useEffect } from "react";
import { keycloak } from "../../keycloak";
import { BASE_URL, LINKEDIN_EXTENSION_REDIRECT_URI } from "../../constants/env.constant";

// This page is for submitting a request for an access_token for 'LinkedIn extension'
const ExtensionPage = () => {
  const token = keycloak.token;

  useEffect(() => {
    if (token) {
      const date = new Date();
      date.setTime(date.getTime() + (60 * 1000));
      document.cookie = `X-ACCESS-TOKEN=${token};expires=${date.toUTCString()};`
    }
     window.location.href = `${BASE_URL}/oauth/authorize?client_id=3&redirect_uri=${LINKEDIN_EXTENSION_REDIRECT_URI}&response_type=token`;
  }, []);

  return (<></>);
};

export default ExtensionPage;
